import { status } from "skin/event/status";

const setInput = (obj, ms, story, data, d, action) => {
  let v = obj.value;
  const err = "Поддомен должен содержать от 1 до 63 символов (латинских или русских букв, цифр, дефисов)";
  const r = new RegExp("^[a-zA-Zа-яА-ЯЁё0-9][a-zA-Zа-яА-ЯЁё0-9-]*[a-zA-Zа-яА-ЯЁё]?$");
  const f = r.test(v);
  if (f) {
    data.setValue("domain2", v.toLowerCase());
    return status.action;
  }
  data.setValue("domain2", v);
  data.setError({ domain: { err } });
  return status.ignore;
};

export default setInput;
